import { KeycloakInitOptions } from 'keycloak-js';

export const iFrameKeyCloakConfig: KeycloakInitOptions = {
  checkLoginIframe: true,
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  pkceMethod: 'S256',
};

export const standardKeyCloakConfig: KeycloakInitOptions = {
  checkLoginIframe: false,
  flow: 'standard',
  onLoad: 'check-sso',
};
